// src/components/PolicyEditor/PolicyEditor.tsx
import React, { useState } from "react";
import { Box, Tabs, Tab, Paper } from "@mui/material";
import PolicyContentEditor from "./PolicyContentEditor";
import TermsEditor from "./TermsEditor";

const PolicyEditor = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#FFF9F7",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        py: 5,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          maxWidth: 1000,
          borderRadius: 3,
          overflow: "hidden",
          backgroundColor: "#fff",
          boxShadow: "0 2px 12px rgba(255, 107, 53, 0.08)",
        }}
      >
        {/* Tabs */}
        <Box sx={{ bgcolor: "#FFFFFF", borderBottom: "2px solid #FFE5DC" }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            centered
            TabIndicatorProps={{
              style: {
                backgroundColor: "#FF6B35",
                height: 3,
              },
            }}
            sx={{
              "& .MuiTab-root": {
                fontSize: "14px",
                fontWeight: 500,
                textTransform: "none",
                py: 2.5,
                px: 4,
                fontFamily: "karbon-medium",
                color: "#999999",
                minHeight: 56,
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#FF6B35",
                  backgroundColor: "#FFF9F7",
                },
              },
              "& .Mui-selected": {
                color: "#FF6B35 !important",
                fontWeight: 600,
              },
            }}
          >
            <Tab label="Terms & Conditions" />
            <Tab label="Privacy Policy" />
          </Tabs>
        </Box>

        {/* Content */}
        <Box sx={{ p: 4, bgcolor: "#FAFAFA" }}>
          {activeTab === 0 && <TermsEditor />}
          {activeTab === 1 && <PolicyContentEditor />}
        </Box>
      </Paper>
    </Box>
  );
};

export default PolicyEditor;
